import { Cancel, CheckCircle, ErrorOutline } from '@/ui/primitives';
import { PlayCircleFilledIcon, ScheduleIcon } from '@/ui/primitives/icons';
import type { SvgIconComponent } from '@/ui/primitives';
import type { BuildStatus, CiConclusion, CiLifecycleState } from '@flowqa/shared';

export const getBuildStatusIconComponent = (
  status: BuildStatus | CiLifecycleState | CiConclusion,
): SvgIconComponent => {
  if (status === 'completed' || status === 'success') return CheckCircle;
  if (status === 'failed' || status === 'canceled' || status === 'timed_out') return Cancel;
  if (status === 'warning') return ErrorOutline;
  if (status === 'running') return PlayCircleFilledIcon;
  return ScheduleIcon;
};
